import { Helmet } from 'react-helmet'
import { helmetJsonLdProp } from "react-schemaorg";
import { absoluteUrl, revese } from '../urls'
import { settings } from '../conf'

import { 
  useUrlParams,
  useLocation
} from '../hooks'

import { 
  useGuide,
  useRoute,
  useInfopanel,
} from '../api'

import {
  STAGE
} from '../trans'


const MetaData = (props) => {
  const {title, description="", canonicalURL, shareImageTitle, jsonLd} = props
  const [location, search] = useLocation()
  const { route_id, trail_id } = useUrlParams(['route_id', 'trail_id']) 
  const guide = useGuide()
  const route = useRoute({ routeId: route_id }, {skip: !route_id})
  const trail = trail_id ? route?.trails[trail_id - 1] : null
  const titles = [guide?.title, route?.title, !!trail ? `${STAGE} ${trail_id} ${trail.title}`: null, title]
  const pageTitle = titles.filter((x, i)=> !!x || titles.indexOf(x) !== i ).join(' | ')
  const pageURL = absoluteUrl(location + search) 
  const baseURL = absoluteUrl(location) 
  const shareImage = absoluteUrl(location + "shareimage.png") 
  const alternateUrls = settings.ALTERNATE_URLS.map(
    (lang) => [
      lang[0], 
      lang[1], 
      lang[2] + location.substring(1, location.length) + search
    ]
  )
  const sharesuffix = shareImageTitle ? `?title=${encodeURIComponent(shareImageTitle)}` : ''
  const webPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pageTitle,
    "description": description,
    "url": pageURL,
    "image": [
      absoluteUrl(location + "shareimage.png" + sharesuffix),
      absoluteUrl(location + "shareimage-1x1.png" + sharesuffix),
      absoluteUrl(location + "shareimage-4x3.png" + sharesuffix),
      absoluteUrl(location + "shareimage-16x9.png" + sharesuffix)
    ],
    "author": {
      "@type": "Organization",
      "name": "Forwalk.org",
      "url": "https://forwalk.org",
      "logo": settings.STATIC_URL + 'images/logo_publisher.svg'
    },
    "publisher": {
      "@type": "Organization",
      "name": "Forwalk.org",
      "url": "https://forwalk.org",
      "logo": settings.STATIC_URL + 'images/logo_publisher.svg'
    }
  }

  if (jsonLd){
    webPageJsonLd["mainEntity"] = jsonLd
  }

  return (
      <Helmet script={[helmetJsonLdProp(webPageJsonLd)]}>
          <title>{pageTitle}</title>
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="og:url" content={pageURL} />
          <meta property="og:image" content={shareImage + sharesuffix} />
          <meta property="og:description" content={description} />
          <link rel="canonical" href={canonicalURL || baseURL} />
          { alternateUrls.map((lang, i) => (
            <link rel="alternate" hreflang={lang[0]} href={lang[2]} key={lang[0]}/>
          ))}
      </Helmet>
  )
}

export default MetaData
